<h2 class="heading">{{ "terms_heading_leverage" | translate }}</h2>

<div class="l-token-summary-container">
  <div class="info">
    <div class="item">
      <p>{{ "tradable_detail_label_leverage" | translate }}</p>
      <h3>{{ vm?.currentLeverage | locale_effective_leverage: 2 }}x</h3>
    </div>
    @if (isBuy) {
      <div class="item">
        <p>{{ "financial_exposure_leverage" | translate }}</p>
        <h3>{{
          (vm?.currentLeverage | absolute) * +offerAmount
          | fiat_precision_symbol
          : {
          id: vm?.fiat.getId(),
          currencies: [vm?.fiat],
          symbol: true,
          customPrecision: vm?.fiat.getPrecisionFiat()
        }
      }}</h3>
    </div>
  } @else {
    <div class="item">
      <p>{{ "future_position" | translate }}</p>
      <h3
        >{{
        futurePosition
        | tradable_precision
        : {
        id: vm?.tradableId,
        addName: false,
        customPrecision: vm?.tradable.getPrecision()
      }
      }}
      {{ vm?.baseSymbol }}
    </h3>
  </div>
}

@if (+currentBorrow > 0) {
  <div class="item">
    <p>{{ "current_position" | translate }}</p>
    <h3
      >{{
      currentBorrow
      | tradable_precision
      : { id: vm?.tradableId, addName: false, customPrecision: vm?.tradable.getPrecision() }
      }}
      {{ vm?.baseSymbol }}
    </h3>
  </div>
}
@if (isBuy) {
  <div class="item">
    <p>{{ "base_price_leverage" | translate }}</p>
    <h3>{{
      vm?.basePrice
      | fiat_precision_symbol
      : {
      id: vm?.fiat.getId(),
      currencies: [vm?.fiat],
      symbol: true,
      customPrecision: vm?.tradable.getPrecisionFiat()
    }
  }}</h3>
</div>
}
<div class="re-leveraging-summary">
  {{ "last_releveraging_date" | translate }}{{ vm?.releverageTime | date_locale }}
</div>
</div>
<!-- overnight fee -->
@if (isBuy) {
  <div class="info-border">
    <div class="additional-info">
      <div class="icon">
        <svg-inline src="/assets/images/overnight-icon.svg" alt="{{ 'logo_alt_text' | translate }}" />
      </div>
      <div class="text">
        {{
        cfdEnabled
        ? ("overnight_alert_leverage_cfd" | translate: [vm?.overnightFee | percent_symbol_precision])
        : ("overnight_alert_leverage" | translate: [vm?.overnightFee | percent_symbol_precision])
        }}
      </div>
    </div>
    <!-- limitation position -->
    @if (!cfdEnabled) {
      <div class="additional-info">
        <div class="icon">
          <svg-inline src="/assets/images/limitation-icon.svg" alt="{{ 'logo_alt_text' | translate }}" />
        </div>
        <div class="text">
          {{ "limitation_position_leverage" | translate }}
        </div>
      </div>
    }
    <!-- Short auto close -->
    @if (cfdEnabled) {
      <div class="additional-info">
        <div class="icon">
          <svg-inline src="/assets/images/auto-close-icon.svg" alt="{{ 'logo_alt_text' | translate }}" />
        </div>
        <div class="text">
          {{
          (vm.isLong ? "cfd_trade_summary_auto_close_long" : "cfd_trade_summary_auto_close_short") | translate
          }}
        </div>
      </div>
    }
  </div>
}
</div>
